import { render, staticRenderFns } from "./studentPersonal.vue?vue&type=template&id=40ef61c6&scoped=true&"
import script from "./studentPersonal.vue?vue&type=script&lang=js&"
export * from "./studentPersonal.vue?vue&type=script&lang=js&"
import style0 from "./studentPersonal.vue?vue&type=style&index=0&id=40ef61c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ef61c6",
  null
  
)

export default component.exports